import ARNecklace from "./ARNecklace";

export default function App() {
  return (
    <div className="container-fluid p-0">
      <div className="row g-0">
        <div className="col-12 ar-container">
          <ARNecklace />
        </div>
      </div>
    </div>
  );
}
